export default __webpack_public_path__ + "static/media/in-gj.42634565.svg";